import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItemSearch = get('reservation.components.ROItemSearch');

export const getROItemSearchQuery = createSelector(
  getROItemSearch,
  get('query')
);
